import { createGlobalStyle } from "styled-components";
import {
  getThemeColor,
  getStyle,
  H02,
  H01,
  H00,
  H04,
  DARK_2c2e2e,
  MAIN_DEEP_WHITE,
  WHITE_f8f8f8,
  // MAIN_DARK,
  H06,
  H09,
  MAIN_PRIMARY,
  MAIN_BLUE,
  DARK_2c3138,
  WHITE_THEME_9d9d9d,
  DARK_THEME_747676,
  MAIN_DEEP_GREEN,
  DARK_0D0E0E,
} from "../constants/colors";
import { MediaScreenMobile } from "components/common/styled";

const GlobalStyle = createGlobalStyle`
  .bit-tabs-main .bit-tabs-tab.bit-tabs-tab-active .bit-tabs-tab-btn {
    color: var(--content-tertiary) !important;
  }
  .bit-modal .bit-modal-content {
          background: var(--cointr-color-fill3);
  }
  .bit-modal .bit-modal-header {
    background: transparent !important;
  }
  .bit-modal .bit-modal-title {
    color: var(--content-tertiary) !important;
  }
  .bit-modal  .bit-modal-close {
   top:14px
  }
  .bit-dropdown-menu-item {
    color: var(--content-tertiary) !important;
  }
  .bit-label-selector .bit-label-selector-item.bit-label-selector-item-active {
    border-color: var(--cointr-color-success1) !important;
    background-color: var(--content-success-bg) !important;
  }
  .bit-label-selector .bit-label-selector-item .bit-label-selector-check-mark-wrapper {
    background-color: var(--cointr-color-success1) !important;
  }
  .bit-label-selector-item {
    background-color: var(--color-bg) !important;
    color: var(--content-tertiary) !important;
  }
  .bit-slider-main-track {
    background: ${getStyle(MAIN_DEEP_GREEN, DARK_0D0E0E)} !important;
  }
    .bit-checkbox-checked .bit-checkbox-inner {
    background: ${getStyle(MAIN_DEEP_GREEN, "#151517")} !important;
    }
    .bit-checkbox-wrapper {
      color: ${getStyle(MAIN_DEEP_WHITE, "#151517")} !important;
    }
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    opcity: 0.1;
    background: var(--background-primary);
  }

  ::-webkit-scrollbar-corner {
    background: var(--background-primary);
  }

  ::-webkit-scrollbar-thumb {
    width: 10px;
    height: 1px;
    border-radius: 10px;
    background: var(--cointr-color-fill2);
  }

  ::-webkit-scrollbar-track {
    background: var(--background-primary);
  }
  .bit-dropdown-menu-item-selected, .bit-dropdown-menu-submenu-title-selected, .bit-dropdown-menu-item-selected > a, .bit-dropdown-menu-submenu-title-selected > a {
    border-radius: 8px;
      // background: ${getThemeColor("dropdown_list_hover_bg")};
    background: ${getStyle(DARK_2c2e2e, WHITE_f8f8f8)};
    color: var(--color-primary) !important;

  }
    .bit-input-search{
    background: ${getStyle(DARK_2c3138, WHITE_f8f8f8)};
      border-color: ${getStyle(DARK_THEME_747676, WHITE_THEME_9d9d9d)};
      input {
        color: var(--content-primary);
      }
    }

    .bit-input{
      background: ${getStyle(DARK_2c3138, WHITE_f8f8f8)};
    }

    .bit-drawer-body {
      background: ${getStyle(DARK_2c3138, WHITE_f8f8f8)};
    }
    
    .bit-drawer-header {
      background: ${getStyle(DARK_2c3138, WHITE_f8f8f8)};
    }
    
    .bit-table-sticky-holder, .bit-table-placeholder, .bit-table-thead,
    .bit-table-placeholder:hover, .bit-table-cell {
      background: ${getStyle(DARK_2c3138, WHITE_f8f8f8)} !important;
    }
     
    .bit-drawer-title,
    .bit-menu-primary-item:not(.bit-menu-primary-item-selected) {
      color: var(--content-primary) !important;
    }

  .rc-scrollbars-thumb {
    background-color: var(--cointr-color-fill2) !important;
  }

  .rc-scrollbars-track {
    background-color: var(--background-primary) !important;
  }

  .rc-scrollbars-container {
    // overflow:unset !important;
    .rc-scrollbars-track-v {
      right: 0;
    }

    .rc-scrollbars-view {
      margin-inline-end: 0 !important;
      // 隐藏火狐浏览器滚动条
      scrollbar-width: none;
      // 防止最后的内容展示不出来
      padding-bottom: 5px;
    }
  }

  .ant-select-dropdown ::-webkit-scrollbar {
    width: 5px;
    background: var(--background-primary);
  }

  .ant-select-dropdown ::-webkit-scrollbar-thumb {
    width: 10px;
    height: 1px;
    background: var(--cointr-color-fill2);
  }

  .ant-select-dropdown ::-webkit-scrollbar-track {
    border-radius: 10px;
    background: var(--background-primary);
  }

  .ant-cascader-menus ::-webkit-scrollbar {
    width: 5px;
    background: var(--background-primary);
  }

  .ant-cascader-menus ::-webkit-scrollbar-thumb {
    width: 10px;
    height: 1px;
    background: var(--cointr-color-fill2);
  }

  .ant-cascader-menus ::-webkit-scrollbar-track {
    border-radius: 10px;
    background: var(--background-primary);
  }

  .colored-text__rise {
    color: var(--content-trade-buy) !important;
  }

  .colored-block__rise {
    background: var(--color-buy) !important;
  }

  .colored-text__fall {
    color: var(--content-trade-sell) !important;
  }

  .colored-block__fall {
    background: var(--color-sell) !important;
  }

  .colored-block__gray {
    background: ${getStyle(H09)} !important;
  }

  .ant-input {
    font-size: 12px;
    background: transparent;
  }

  .with-tooltip__border-bottom {
    border-bottom: 1px dashed var(--border-strength-200);

    .iconfont {
      font-size: 12px;
      margin-inline-start: 5px;
    }
  }

  .ant-btn.buyer {
    background: var(--color-green) !important;
    border-color: var(--color-green) !important;
    color: #ffffff;
  }

  .ant-btn.seller {
    background: var(--color-red) !important;
    border-color: var(--color-red) !important;
    color: #ffffff;
  }

  .ant-btn[disabled] {
    background: ${getStyle(H02)};
    border-color: transparent;
    color: ${getStyle(H00)};

    &:hover, &:active {
      border-color: transparent !important;
      color: ${getStyle(H00)} !important;

      background-color: ${getStyle(H02)} !important;
    }
  }

  .ant-message {
    .ant-message-notice-content {
      max-width: 500px;
    }

    .ant-message-custom-content {
      display: flex;
      align-items: center;
    }
  }

  // 覆盖部分级联选择器样式
  .global-cascader__fix {

    .ant-cascader-menu {
      min-width: 190px;

      .ant-cascader-menu-item {
        padding: 8px 20px;
        border-radius: 4px;

        &:hover {
          background-color: #ecf3ff;
        }
      }

      .ant-cascader-menu-item-active {
        color: var(--color-primary);
        background: transparent;
      }
    }
  }

  // 覆盖滑动条标记的样式
  .ant-slider {
    margin-block: 14px 10px; 
    margin-inline: 7px 10px;

    .ant-slider-track {
      background-color: var(--color-primary);
    }

    &-rail {
      background-color: ${getStyle(H02)};

    }

    &:hover {
      .ant-slider-rail {
        background-color: ${getStyle(H02)};

      }

      .ant-slider-track {
        background-color: var(--color-primary);
      }


      .ant-slider-handle {
        border-color: var(--color-primary);
      }
    }

    .ant-slider-dot {
      background: ${getStyle(H02)};
      border: 2px solid ${getStyle(H02)};
      width: 10px;
      height: 10px;
      top: -3px;
    }

    .ant-slider-handle {
      border-color: var(--color-primary);
      background: ${MAIN_DEEP_WHITE};
    }

    .ant-slider-dot-active {
      border-color: var(--color-primary);
      background: var(--color-primary);
    }
  }

  .ant-slider-disabled {
    .ant-slider-dot-active {
      border-color: var(--color-primary);
      background: ${MAIN_DEEP_WHITE};
    }

    .ant-slider-track {
      background-color: ${getStyle(MAIN_DEEP_WHITE, "rgba(0, 0, 0, 0.25)")} !important;
    }
  }

  .ant-slider-mark {
    font-size: 12px;
  }

  .ant-slider-mark-text {
    color: ${getStyle(H01)};
  }

  .dark, .black {
    .loading-img__dark {
      display: inline-block !important;
    }

    .loading-img__white {
      display: none !important;
    }
  }

  .light, .white {
    .loading-img__dark {
      display: none !important;
    }

    .loading-img__white {
      display: inline-block !important;
    }
  }

  .ant-checkbox-checked::after {
    border: 1px solid var(--color-primary);
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: var(--color-primary);
    border-color: var(--color-primary);
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner, .ant-checkbox:hover .ant-checkbox-inner, .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: var(--color-primary);
  }

  .bit-tooltip-inner {
    font-size: 12px;
  }
  .ant-btn {
    text-shadow: none;
    box-shadow: none;

    &:hover, &:focus {
      color: var(--color-primary-hover-sk);
      border-color: var(--color-primary-hover-sk);
    }

    &:active {
      color: var(--color-primary-pressed-sk);
      border-color: var(--color-primary-pressed-sk);
    }

    &.ant-btn-primary {
      &:hover, &:focus {

        color: #ffffff;
        border-color: var(--color-primary-hover-sk);
        background: var(--color-primary-hover-sk);
      }

      &:active {
        border-color: var(--color-primary-pressed-sk);
        background: var(--color-primary-pressed-sk);
      }
    }
  }

  .ant-tooltip-inner {
    background: var(--background-popup);
    border-radius: 8px;
    font-size: 12px;
    max-width: 256px;
    font-weight: 400;
    line-height: 16px;
    padding:8px  12px;
    color: var(--content-always-white);
  }

  .ant-tooltip-arrow {
      .ant-tooltip-arrow-content {
        box-shadow: none;
      }
      
      .ant-tooltip-arrow-content::before {
          background: var(--background-popup);
          width: 21px;
          height: 21px;
      }
  }

  .ant-popover-inner-content {
    background: ${getThemeColor("content_bg_special")};
    padding: 15px;
  }

  .ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow {
    border-top-color: ${getThemeColor("content_bg_special")};
    border-inline-start-color: ${getThemeColor("content_bg_special")};
    border-inline-end-color: transparent;
    border-bottom-color: transparent;
  }

  .ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow,
  .ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow,
  .ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {
    border-top-color: transparent;
    border-inline-end-color: ${getThemeColor("content_bg_special")};
    border-bottom-color: ${getThemeColor("content_bg_special")};
    border-inline-start-color: transparent;
  }

  .ant-modal-close-x {
    width: 30px;
    line-height: 26px;
    color: ${getStyle(H00)};

    .iconfont {
      color: ${getStyle(H00)};
      font-size: 12px;
    }
  }

  .ant-modal {
    .ant-checkbox-wrapper {
      span:nth-child(2) {
        color: ${getStyle(H01)};
      }
    }

    .ant-dropdown-trigger {
      color: ${getStyle(H00)}
    }

    .ant-input {
      font-size: 12px;
      background: transparent;
    }
  }

  .ant-dropdown-trigger:hover {
    border-color: var(--color-secondary-text) !important;
  }

  .ant-modal-content {
    background: none;
  }

  .ant-menu {
    transition: none;
    max-height: 600px;


  }

  .ant-dropdown-menu-item {
    transition: none;
    padding: 0

  }

  .ant-dropdown-menu-item:hover, .ant-dropdown-menu-submenu-title:hover {
    opacity: 1;
    // color: var(--content-link-hover);
    background: var(--background-secondary);
    border-radius: 8px;
  }
  
  .ant-menu-item-active.ant-menu-item:hover,
  .ant-dropdown-menu-submenu-title:hover,
  .ant-dropdown-menu-item.ant-dropdown-menu-item-active,
  .ant-menu-item-selected {
      background-color: var(--background-secondary) !important;
  }
  
  .ant-select-dropdown {
    background: ${getThemeColor("dropdown_menu")};

    .ant-select-item {
      background: ${getThemeColor("dropdown_menu")};
      color: ${getThemeColor("dropdown_menu_text")};
      font-weight: normal;
      margin-block: 0 6px; 
      margin-inline: 6px;
      border-radius: 8px;

      &:hover {
        background: ${getThemeColor("dropdown_list_hover_bg")};
        color: ${MAIN_PRIMARY};
      }
    }
  }

  .ant-cascader-menus {
    background: ${getThemeColor("dropdown_menu")};
    border-radius: 4px;
    padding: 3px 8px;

    .ant-cascader-menu {
      border-inline-end: 1px solid ${getStyle(H02)};

      &:last-child {
        border-inline-end-color: transparent;
      }

      .ant-cascader-menu-item {
        color: ${getThemeColor("text_white_5")};
        margin-bottom: 4px;
      }

      .ant-cascader-menu-item:hover {
        background-color: ${getThemeColor("dropdown_list_hover_bg")};
        color: var(--color-primary);
      }

      .ant-cascader-menu-item-active {
        color: var(--color-primary);
        background-color: ${getThemeColor("dropdown_list_hover_bg")};

      }
    }
  }

  .ant-menu-submenu-title:active, .ant-menu-item:active {
    color: var(--color-primary) !important;
    background: ${getThemeColor("dropdown_list_hover_bg")};
  }

  .ant-dropdown-menu-item-selected, .ant-dropdown-menu-submenu-title-selected, .ant-dropdown-menu-item-selected > a, .ant-dropdown-menu-submenu-title-selected > a {
    border-radius: 8px;
    background: var(--background-secondary);
  }

  //Popover引导样式覆盖
  .gride-popover1 .ant-popover-inner-content {
    min-width: 376px;
    color: #fff;
    background: var(--color-primary);
    padding: 15px;
    border-radius: 4px
  }

  .gride-popover2 {
    border-radius: 4px !important;
  }

  .gride-popover2 .bit-popover-inner-content {
    min-width: 376px;
    color: #fff;
    background: var(--color-primary);
    padding: 15px;
    border-radius: 4px !important;
  }

  .gride-popover1 .ant-popover-inner {
    border-radius: 4px
  }

  .gride-popover2 .bit-popover-inner {
    border-radius: 4px !important;
    padding: 0 !important;
    border: 0 !important;
  }

  .gride-popover2 .bit-popover-arrow {
    display: none !important;
  }

  .gride-popover1 > .ant-popover-content > .ant-popover-arrow, .ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow, .ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {
    top: 6px;
    border-top-color: var(--color-primary);
    border-inline-end-color: var(--color-primary);
    border-bottom-color: transparent;
    border-inline-start-color: var(--color-primary);
    -webkit-box-shadow: -2px -2px 5px rgb(0 0 0 / 6%);
    box-shadow: -2px -2px 5px rgb(0 0 0 / 6%);
  }

  //Popover引导样式覆盖
  .new-guide .ant-popover-inner-content {
    position: relative;
    width: 320px;
    color: #fff;
    background: var(--color-primary);
    padding: 20px 16px;
    border-radius: 4px
  }

  .new-guide-five {
    @media screen and (max-width: 767px) {
      top: 80px !important;
    }
  }

  .new-guide-six {
    @media screen and (max-width: 767px) {
      top: auto !important;
      bottom: -93vh !important;
      .ant-popover-arrow {
        top: auto !important;
        bottom: 6px !important;
      }
    }
  }

  .new-guide .ant-popover-inner {
    border-radius: 4px
  }

  .new-guide > .ant-popover-content > .ant-popover-arrow, .ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow, .ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {
    top: 6px;
    border-top-color: var(--color-primary);
    border-inline-end-color: var(--color-primary);
    border-bottom-color: var(--color-primary);
    border-inline-start-color: var(--color-primary);
    -webkit-box-shadow: -2px -2px 5px rgb(0 0 0 / 6%);
    box-shadow: -2px -2px 5px rgb(0 0 0 / 6%);
  }

  .new-guide1 > .ant-popover-content > .ant-popover-arrow {
    left: 220px !important;
  }

  //Popover引导样式覆盖
  .gride-popover3 {
    position: absolute;
    left: 55px !important;
    // transform: translateX(58px)!important;
    transform: scale(1);
    // opacity:1 !important;
    animation-name: bounce-down !important;
    animation-duration: 1.6s;
    animation-timing-function: linear;
    animation-iteration-count: 3;
    animation-fill-mode: backwards;
  }

  .gride-popover3 .ant-popover-inner-content {
    min-width: 250px;
    color: #fff;
    background: var(--color-primary);
    padding-block: 15px 10px;
    padding-inline: 15px;
    border-radius: 4px;

  }

  .gride-popover3 .ant-popover-inner {
    border-radius: 4px;
  }

  .gride-popover3 > .ant-popover-content > .ant-popover-arrow, .ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow, .ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {
    top: 6px;
    border-top-color: var(--color-primary);
    border-inline-end-color: var(--color-primary);
    border-bottom-color: transparent;
    border-inline-start-color: var(--color-primary);
    -webkit-box-shadow: -2px -2px 5px rgb(0 0 0 / 6%);
    box-shadow: -2px -2px 5px rgb(0 0 0 / 6%);
  }

  @keyframes bounce-down {
    25% {
      transform: translateY(-4px);
    }
    50%, 100% {
      transform: translateY(0);
    }
    75% {
      transform: translateY(4px);
    }
  }


  .gride-popover2 .ant-popover-inner-content {
    min-width: 376px;
    color: #fff;
    background: var(--color-primary);
    padding: 15px;
    border-radius: 4px

  }

  .gride-popover2 .ant-popover-inner {
    border-radius: 4px
  }

  .gride-popover2 > .ant-popover-content > .ant-popover-arrow, .ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow, .ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {
    top: 7px;
    border-top-color: var(--color-primary);
    border-inline-end-color: var(--color-primary);
    border-bottom-color: transparent;
    border-inline-start-color: var(--color-primary);
    -webkit-box-shadow: -2px -2px 5px rgb(0 0 0 / 6%);
    box-shadow: -2px -2px 5px rgb(0 0 0 / 6%);
  }

  .copytrading-popover .ant-popover-arrow {
    display: none;
  }
  .copytrading-popover .ant-popover-inner {
    border-radius: 8px;
    background: var(--color-sk);
    border: 1px solid var(--color-line);
  }
  .copytrading-popover .ant-popover-inner-content {
    padding: 16px 0px;
    border-radius: 8px;
    background: var(--color-sk);
  }

  .ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon {
    color: ${getStyle(H00)};
  }

  .ant-drawer-content {
    // border-radius: 16px 16px 0 0;
    background: ${getThemeColor("dropdown_menu")};

  }

  a:hover {
    color: var(--color-primary);
  }

  #root {
    height: 100%;
  }

  // 适配移动端
  ${MediaScreenMobile(`
    #launcher {
      display: none;
    }
  `)}
    //抽屉全局样式
  .ant-drawer-content .ant-drawer-header {
      // background: ${getStyle(H04)} !important;
    background: var(--color-card-sk) !important;
  }


  .dialogs-drawer {
    .ant-drawer-header {
      line-height: 50px;
        // background: ${getStyle(H04)} !important;
      border-bottom: 1px solid ${getStyle(H02)} !important;

      .ant-drawer-title {
        font-weight: 500;
        font-size: 18px;
        color: ${getStyle(H00)};

        .h5-tabs {
          width: 80%
        }
      }
    }
  }

  .ant-drawer-content {
      // background: ${getThemeColor("dropdown_menu")};
  }

  .rc-scrollbars-view {
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .h5-pc-order-placer-wrap {
    .ant-slider-with-marks {
      margin: 10px 7px 10px;
    }

    .ant-slider-mark-text {
      &:first-child {
        transform: translateX(-10%) !important;
      }

      &:last-child {
        transform: translateX(-90%) !important;
      }

    }
  }

  .drag-wrap {
    position: relative;
    padding: 4px;
    background: var(--background-secondary);

    &:hover .cancle-btn {
      z-index: 99;
      opacity: 1;
    }

    .drag-handle-icon {
      position: absolute;
      z-index: 99;
      top: 12px;
      right: 10px;
      left: unset;
      cursor: grab;
      font-size: 0;

      svg {
          color: var(--content-tertiary);
      }
    }

    [dir=rtl].drag-handle-icon {
      right: unset;
      left: 10px;
    }
       
    .resize-handle {
        position: absolute;
        cursor: se-resize;
        bottom: 4px;
        right: 4px;
        width: 8px;
        height: 8px;
        border-right: 1px solid var(--content-tertiary);
        border-bottom: 1px solid var(--content-tertiary);
        border-bottom-right-radius: 4px;
    }
  }

  .position-list-warp {
      /* background: ${getThemeColor("content_bg")}; */
    height: 100%;
    // overflow: hidden;
    min-height: 200px;
    border-radius: 4px;
  }

  .ant-drawer-header-no-title {
    padding: 0px !important;
  }
  
  .ant-drawer-header-close-only{
      padding: 0px !important;
  }

  /* 
    //Popover 引导样式覆盖  现货 抵扣下单那块的 vip等级点击出的弹窗
    .vip-margin-fee-popover1 .ant-popover-inner-content {
      min-width: 332px;
      background: var(--color-card-sk);
      padding: 16px;
      border-radius: 4px;
      border: 1px solid var(--color-input-border);
    }
  
    .vip-margin-fee-popover1 .ant-popover-inner {
      border-radius: 4px;
      background-color: var(--color-card-sk);
    } */


  /* .vip-margin-fee-popover1 > */
  .ant-popover-content > .ant-popover-arrow, .ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow, .ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {
    top: 6px;
    border-top-color: var(--color-card-sk);
    border-inline-end-color: var(--color-card-sk);
    border-bottom-color: transparent;
    border-inline-start-color: var(--color-card-sk);
    -webkit-box-shadow: -2px -2px 5px rgb(0 0 0 / 6%);
    box-shadow: -2px -2px 5px rgb(0 0 0 / 6%);
  }


  // message 样式
  .bit-message {
    border-color: transparent !important;
    background-color: transparent !important;
    box-shadow: none !important;
    display: block;
    z-index: 3000;
  }
  .black .bit-message,
  .dark .bit-message {
    .bit-message-notice {
      .bit-message-notice-content {
        background-color: var(--cointr-color-fill2);
        border-color: var(--border-strength-100);
        span:nth-child(2) {
          color: var(--content-primary);
        }
      }
    }
  }
  
  .bit-input-prefix {
      font-size: 12px;
  }

  // 策略自动发布
  .auto-publish .ant-modal-close{
    display: none;
  }
  .auto-publish .ant-modal-body{
    padding: 32px;
  }
  .auto-publish .ant-popover-inner {
    background: var(--color-primary);
  }
  .auto-publish .ant-popover-inner-content {
    position: relative;
    width: 426px;
    color: #fff;
    background: var(--color-primary);
    padding: 20px 16px;
    border-radius: 4px
  }
  .auto-publish .ant-popover-arrow{
    border-color: var(--color-primary) !important;
  }
  .ant-popover-arrow-content::before {
    background: none !important;
  }
  .signDetailBox {
    .bit-tabs-content-holder {
        overflow-y: scroll;
        max-height: calc(100vh - 132px - 64px - 85px - 120px);
    }
  }
`;

export default GlobalStyle;
